<template lang="pug">
  div.invoice-control.bank-statements
    e-toolbar(
      :items="items"
      :hideRemoveButton="true"
      :showTotal="true"
      :showViewPanel="false"
      :hideImportBtn="true"
    )

    e-table(
      :defaultColumnWidth="150"
      :items="items"
      :showCheckbox="false"
      :showDeleteButton="false"
      :showEditButton="false"
      @rowClick="onRowClick"
    )
      div(slot="file" slot-scope="{row}")
        a(
          v-if="row.file"
          href="#"
          @click.stop.prevent="startDownloadFile(row)"
        ) {{row.file}}

    router-view
</template>

<script>
  import {invoiceControl} from '../../api/api-endpoints.js'
  import tableMixin from "../../components/table/table-mixin.js"

  export default {
    mixins: [tableMixin],
    created () {
      if (this.items && !this.items._meta.fields.file) {
        this.$store.commit(
          'mutateError',
          new Error('В мете отсутствует file требуемое для отображения ссылки на скачивания!')
        )
      }
    },
    methods: {
      onRowClick({id}) {
        this.$router.push({
          name: 'invoiceControl.bankStatementItems',
          params: {statementId: id}
        })
      },
      getEndpoint (route) {
        return invoiceControl.bankStatements(route)
      },
      getDownloadEndpoint (row) {
        return invoiceControl.bankStatementDownload(row.id)
      }
    }
  }
</script>
